import moment from 'moment'

export default {
  computed: {
    SHOW_SYSTEM_UPDATE_ALERT() {
      return process.env.VUE_APP_SHOW_SYSTEM_UPDATE_ALERT === 'true'
    },
  },
  mounted() {
    if (this.SHOW_SYSTEM_UPDATE_ALERT) {
      const lastShown = localStorage.getItem('showAlert')
      console.log(moment(lastShown).valueOf(), moment(new Date()).valueOf(), moment(lastShown).valueOf() <= moment(new Date()).valueOf())
      if (lastShown) {
        if (moment(lastShown).valueOf() + 24 * 60 * 60 * 100 <= moment(new Date()).valueOf()) {
          this.$refs.myModal.show()
          localStorage.setItem('showAlert', new Date())
        }
      } else {
        this.$refs.myModal.show()
        localStorage.setItem('showAlert', new Date())
      }
    }
  },
}
